var _clipPath;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconR-bell-disc",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    style: {
      fill: "#293583"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.986,30.893c1.297,0 2.414,-0.874 2.656,-2.033c0.009,-0.045 -0.003,-0.091 -0.033,-0.127c-0.029,-0.035 -0.073,-0.056 -0.119,-0.056c-0,0 -5.008,0 -5.008,0c-0.046,0 -0.09,0.021 -0.12,0.056c-0.029,0.036 -0.041,0.082 -0.032,0.127c0.242,1.159 1.359,2.033 2.656,2.033Zm9.868,-5.849c-0.934,-0.947 -2.686,-2.37 -2.686,-7.039c-0,-3.289 -2.444,-5.92 -5.735,-6.566c-0.151,-0.029 -0.258,-0.156 -0.258,-0.302c-0,0 -0,-0.922 -0,-0.922c-0,-0.613 -0.527,-1.108 -1.175,-1.108c-0.648,-0 -1.175,0.495 -1.175,1.108l0,0.922c0,0.146 -0.107,0.273 -0.258,0.302c-3.291,0.646 -5.735,3.277 -5.735,6.566c0,4.669 -1.752,6.092 -2.686,7.039c0,0 0,0 0,0c-0.219,0.223 -0.317,0.488 -0.315,0.748c-0,0 -0,0 -0,0c0.004,0.57 0.477,1.111 1.18,1.111l17.978,-0c0.703,-0 1.177,-0.541 1.18,-1.111c0,0 0,0 0,0c0.002,-0.26 -0.096,-0.526 -0.315,-0.748c-0,0 -0,0 -0,0Zm-4.284,-7.042l-0,0.003c0.01,3.598 1.055,5.607 2.012,6.888c0.118,0.158 0.163,0.202 0.241,0.278c0.154,0.148 -0.079,0.223 -0.159,0.223l-15.331,0c-0.11,0 -0.326,-0.034 -0.181,-0.193c0.049,-0.054 0.205,-0.231 0.262,-0.302c0.965,-1.202 2.013,-3.269 2.016,-6.894l0,-0.001c0.001,-2.907 2.493,-5.264 5.57,-5.264c3.076,-0 5.568,2.355 5.57,5.262Z",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRBell);
export default __webpack_public_path__ + "static/media/iconR-bell.bb1bc696d37da7ffc4aa9e39ff3bb430.svg";
export { ForwardRef as ReactComponent };